import { render, staticRenderFns } from "./requestsReject.vue?vue&type=template&id=36bc6d26&"
import script from "./requestsReject.vue?vue&type=script&lang=js&"
export * from "./requestsReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports